import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const Features = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const tr = i18n.language?.startsWith('tr');

  const page = tr
    ? {
        title: 'Özellikler',
        subtitle: 'Kurumsal erişimi yönetmek için net, kullanılabilir yetenekler.',
        groups: [
          {
            title: 'Güvenlik ve gizlilik',
            items: [
              { title: 'Uçtan uca koruma', body: 'Kurumsal trafiği şifreleyin; varsayılanlar dengeli, politika net.', points: ['Modern şifreleme', 'Sıfır gereksiz log', 'Oturum güvenliği'] },
              { title: 'Kimlik doğrulama', body: 'E-posta doğrulama ve iki adımlı kontrollerle hesapları koruyun.', points: ['E-posta doğrulama', '2FA akışı', 'Oturum süreleri'] },
              { title: 'Kill switch', body: 'Bağlantı düşünce cihazın açıkta kalmasını engelleyen koruma katmanı.', points: ['Otomatik kesme', 'Politika ile aç/kapa', 'Masaüstü desteği'] },
            ],
          },
          {
            title: 'Erişim ve performans',
            items: [
              { title: 'Hızlı bağlantı', body: 'Günlük iş için yeterli hızda, az sürtünmeli oturumlar.', points: ['Düşük gecikme odaklı', 'Stabil yeniden bağlanma', 'Çok cihaz'] },
              { title: 'Split tunneling', body: 'Sadece gereken trafiği tünele alın; gerisini doğrudan bırakın.', points: ['Uygulama bazlı', 'Rota kontrolü', 'Bant genişliği tasarrufu'] },
              { title: 'Platform kapsamı', body: 'Windows, macOS, Linux, iOS ve Android üzerinde aynı erişim modeli.', points: ['Masaüstü istemciler', 'Mobil uygulamalar', 'Merkezi politika'] },
            ],
          },
          {
            title: 'Yönetim',
            items: [
              { title: 'Şirket paneli', body: 'Kullanıcı davetleri, roller ve şirket ayarları tek yerde.', points: ['Davet kodları', 'Rol yönetimi', 'Şirket görünümü'] },
              { title: 'Bağlantı görünürlüğü', body: 'Kim ne zaman bağlandı — operasyon için yeterli netlik.', points: ['Bağlantı geçmişi', 'Aktif oturumlar', 'Basit raporlama'] },
              { title: 'Lisans ve planlar', body: 'Kullanıcı, cihaz ve bağlantı limitlerini plana göre yönetin.', points: ['Plan limitleri', 'Büyüme yolu', 'Kurumsal seçenek'] },
            ],
          },
        ],
        ctaTitle: 'Ekibiniz için uygun mu?',
        ctaBody: 'Kısa bir deneme ile özellikleri kendi ortamınızda görün.',
        cta: 'Hesap oluştur',
      }
    : {
        title: 'Features',
        subtitle: 'Clear capabilities for managing corporate access without clutter.',
        groups: [
          {
            title: 'Security & privacy',
            items: [
              { title: 'End-to-end protection', body: 'Encrypt company traffic with balanced defaults and clear policy.', points: ['Modern encryption', 'Minimal logging', 'Session hygiene'] },
              { title: 'Authentication', body: 'Protect accounts with email verification and two-step checks.', points: ['Email verification', '2FA flow', 'Session lifetimes'] },
              { title: 'Kill switch', body: 'Reduce exposure when a tunnel drops unexpectedly.', points: ['Automatic cut-off', 'Policy toggle', 'Desktop support'] },
            ],
          },
          {
            title: 'Access & performance',
            items: [
              { title: 'Responsive sessions', body: 'Fast enough for daily work with low friction reconnects.', points: ['Latency-minded', 'Stable reconnect', 'Multi-device'] },
              { title: 'Split tunneling', body: 'Send only the traffic that needs the tunnel.', points: ['App-aware routes', 'Route control', 'Bandwidth savings'] },
              { title: 'Platform coverage', body: 'Same access model across desktop and mobile.', points: ['Desktop clients', 'Mobile apps', 'Central policy'] },
            ],
          },
          {
            title: 'Administration',
            items: [
              { title: 'Company console', body: 'Invites, roles, and company settings in one place.', points: ['Invite codes', 'Role management', 'Company view'] },
              { title: 'Connection visibility', body: 'Enough clarity for operations without noise.', points: ['Connection history', 'Active sessions', 'Simple reporting'] },
              { title: 'Licenses & plans', body: 'Grow users, devices, and connections with clear limits.', points: ['Plan limits', 'Upgrade path', 'Enterprise option'] },
            ],
          },
        ],
        ctaTitle: 'See if it fits your team',
        ctaBody: 'Start a short trial and try the features in your own environment.',
        cta: 'Create account',
      };

  return (
    <PublicLayout title={page.title} subtitle={page.subtitle}>
      <div className="common-page">
        {page.groups.map((group) => (
          <section className="arc-section" key={group.title} style={{ paddingTop: '1.5rem' }}>
            <div className="arc-section-head">
              <h2>{group.title}</h2>
            </div>
            <div className="arc-grid-3">
              {group.items.map((item) => (
                <article className="arc-panel feature-rich" key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                  <ul className="arc-list-plain">
                    {item.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </section>
        ))}

        <section className="arc-cta-band">
          <h2>{page.ctaTitle}</h2>
          <p>{page.ctaBody}</p>
          <button type="button" className="arc-btn arc-btn-solid arc-btn-lg" onClick={() => navigate('/signup')}>
            {page.cta}
          </button>
        </section>
      </div>
    </PublicLayout>
  );
};

export default Features;
